import React, { forwardRef } from 'react';

import DataGrid, { Column, Export, Lookup, Pager, Paging } from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import { Button } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import { RowDblClickEvent } from 'devextreme/ui/data_grid';

import { NomenclatureTransfer } from 'bus/nomenclatureTransfer/types';

type Props = {
  onRefreshList: () => void;
  onAdd: () => void;
  onRowDblClick: (row: RowDblClickEvent<NomenclatureTransfer>) => void;
  onClickEdit: (id: number) => void;
  onClickRemove: (id: number) => void;
  dataSourceNomenclatureTransferList: DataSource;
  storeMaterial: any;
  unitDataSource: any;
};

export const NomenclatureTransferListPage = forwardRef<DataGrid, Props>(
  (
    {
      onAdd,
      onRefreshList,
      onRowDblClick,
      onClickEdit,
      onClickRemove,
      dataSourceNomenclatureTransferList,
      storeMaterial,
      unitDataSource,
    },
    ref,
  ) => {
    return (
      <div>
        <AppLayoutTop title="Перекидка">
          <Button icon="refresh" onClick={onRefreshList} />
          <ClaimsProvider claimsBlock={['CanEditNomenclatureTransferSection']}>
            <Button width={120} text="Добавить" type="default" onClick={onAdd} />
          </ClaimsProvider>
        </AppLayoutTop>

        <AppCard>
          <DataGrid
            dataSource={dataSourceNomenclatureTransferList}
            showBorders={false}
            loadPanel={{
              enabled: true,
              text: 'Загрузка',
            }}
            key="id"
            ref={ref}
            allowColumnResizing
            columnResizingMode="nextColumn"
            columnMinWidth={50}
            onRowDblClick={onRowDblClick}
          >
            <Column dataField="id" caption="Номер" />
            <Column dataField="date" caption="Дата" dataType="date" sortOrder="desc" width={150} />
            <Column dataField="nomenclatureId" caption="Материал" width={200}>
              <Lookup dataSource={storeMaterial} valueExpr="id" displayExpr="name" />
            </Column>
            <Column caption="Откуда" dataField="sourceFactory" />
            <Column caption="Куда" dataField="destinationFactory" />
            <Column dataField="driverSalary" caption="Цена за рейс" />
            <Column dataField="totalQuantity" caption="Количество" />
            <Column dataField="unitId" caption="Ед. изм.">
              <Lookup dataSource={unitDataSource} valueExpr="id" displayExpr="name" />
            </Column>
            <Column dataField="comment" caption="Комментарий" />

            <Column
              dataField="actions"
              caption=""
              width={120}
              cellRender={(data) => (
                <>
                  <ClaimsProvider claimsBlock={['CanEditNomenclatureTransferSection']}>
                    <Button icon="edit" type="default" stylingMode="text" onClick={() => onClickEdit(data.data.id)} />

                    <Button
                      icon="trash"
                      type="default"
                      stylingMode="text"
                      onClick={() => onClickRemove(data.data.id)}
                    />
                  </ClaimsProvider>
                </>
              )}
            />

            <Export enabled={true} />
            <Paging defaultPageSize={15} />
            <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
          </DataGrid>
        </AppCard>
      </div>
    );
  },
);
